import { Col, Row, Spin } from 'antd';
import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../../../_config/utils/get-local-storage-value.util';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import CustomTextArea from '../../../../../v2-components/Antd/TextArea';
import { SELECT_DICTIONARY } from './constants/dictionary.constant';
import { options } from './constants/options.constant';
import { statusNames } from './constants/status-names.constant';
import { getReason } from './handle/get-reason.handle';
import { getStatusDetail } from './handle/get-status-detail.handle';
import { hideComponent } from './handle/hide-component.handle';
import { renderButtons } from './handle/render-buttons.handle';

export default function StatusCard(props) {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openCancel, setOpenCancel] = useState(false);
	const [textAreaValue, setTextAreaValue] = useState();
	const [reason, setReason] = useState('any');

	const body = {
		reason: getReason(reason, textAreaValue),
		qf_email: GetLocalStorageValue('userInfo').email,
	};

	const handleCancel = () => {
		setOpenCancel(true);
	};

	const handleReject = async () => {
		setOpenCancel(false);
		await props.handleCancelReserve(body);
		props.setIsLoading(false);
	};

	const handleConfirm = async () => {
		setOpenConfirm(false);
		await props.handleApproveReserve(body);
		props.setIsLoading(false);
	};

	const handleNext = () => {
		setOpenConfirm(true);
	};

	const handleChange = (value) => {
		setReason(value);
	};

	const handleTextArea = (e) => {
		setTextAreaValue(e.target.value);
	};

	const renderTextArea = (reason) => {
		if (reason === SELECT_DICTIONARY.others) {
			return (
				<Row style={{ display: hideComponent(reason), width: '100%' }}>
					<span>Comentarios</span>
					<CustomTextArea placeholder={'Mensaje personalizado'} onChange={handleTextArea} />
				</Row>
			);
		}
	};

	if (props?.isLoading) {
		return (
			<div className="spin-container">
				<Spin />
			</div>
		);
	}

	return (
		<Row>
			<Row>
				<Col span={24}>
					<h3>Estado de la solicitud</h3>
					<span>{statusNames[Enviroment.LANGUAGE][props?.statusNumber]}</span>
					<p>{getStatusDetail(props?.status)}</p>
				</Col>
			</Row>
			{renderButtons(props?.statusNumber, handleCancel, handleNext)}
			<CustomModal onCancel={() => setOpenConfirm(false)} footer={null} open={openConfirm}>
				<h2>Confirmar reserva</h2>
				<CustomDivider />
				<h3>Al continuar estas confirmando:</h3>
				<ul>
					<li>Que las recetas son consistentes con lo pedido</li>
					<li>Que tienes stock de los productos solicitados</li>
				</ul>
				<CustomDivider />
				<div className="button-container">
					<CustomButton onClick={() => setOpenConfirm(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleConfirm}>Aprobar</CustomButton>
				</div>
			</CustomModal>

			<CustomModal onCancel={() => setOpenCancel(false)} footer={null} open={openCancel}>
				<h2>Rechazar reserva</h2>
				<CustomDivider />
				<h3>Seleccione el motivo del rechazo</h3>

				<CustomSelect
					bordered={true}
					onChange={handleChange}
					style={{ width: '100%', marginBottom: '20px' }}
					options={options[Enviroment.LANGUAGE]}
					placeholder="Seleccionar motivo"
				/>
				<Row>{renderTextArea(reason)}</Row>
				<CustomDivider />
				<div className="button-container">
					<CustomButton onClick={() => setOpenCancel(false)}>Cancelar</CustomButton>
					<CustomButton onClick={handleReject}>Rechazar </CustomButton>
				</div>
			</CustomModal>
		</Row>
	);
}
